module.exports = __webpack_public_path__ + "img/description-2.e63f5bd9.png";